module.exports = __webpack_public_path__ + "static/media/bw-social-ig.bd1d6dde.svg";